export default "/images/vendor/quill/icons/float-right.svg?a595de253808219158737e11e9172a1a";